export const Baloons = () => {
  return (
    <img
      src="/assets/svg/baloons.svg"
      alt="Celebration"
      style={{
        maxWidth: "100%",
        height: "150px",
      }}
    />
  );
};
